import React, {useState, useEffect} from 'react';
import * as C from '../../Common.styles';
import * as S from './AlmostDone.styles';
import IconSelector from '@ibibo/icon-selector';
import {useSelector, useDispatch} from 'react-redux';

import Eye from '../CreatePassword/EyeIcon';
import {getTerms} from '../../../../../store/actions/thunk';

import {validations} from '../../../../../utils/validations';
import {sendEvarData} from '@ibibo/analytics';

import ButtonLoader from '../../../UI/Loader/Loader';
import {tokenSelector, agencyNameSelector, fullnameSelector, addressSelector, gstNumberSelector, panNumberSelector, emailSelector, mobileSelector, verify_mmt_passwordSelector, account_existsSelector, account_existsMessageSelector} from '../../../../../store/selectors';

const AlmostDone = ({setPassword, mobileUser, setLoader, apiError, onforgotPwdClickHandler, tokenApiMessage, forgotPasswordLoader}) => {

    const dispatch = useDispatch();

    const [{user_name, password, confirm_pass}, setUserPass] = useState({
        user_name: mobileUser,
        password: '',
        confirm_pass: ''
    });

    const [userAgree, setUserAgree] = useState('');
    const [userConsent, setUserConsent] = useState('');


    const [apiErrorMsg, setApiError] = useState(apiError);
    const [errors, setError] = useState({});
    const [popVisible, setpopVisible] = useState(false);
    const [userAgreed, setUserAgreed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const token = useSelector(tokenSelector);
    const agency_name = useSelector(agencyNameSelector);
    const agent_name = useSelector(fullnameSelector);
    const address = useSelector(addressSelector);
    const gstin = useSelector(gstNumberSelector);
    const pan_details = useSelector(panNumberSelector);
    const email = useSelector(emailSelector);
    const mobile = useSelector(mobileSelector);
    const account_exists = useSelector(account_existsSelector);
    const verify_mmt_password = useSelector(verify_mmt_passwordSelector);
    const account_existsMessage = useSelector(account_existsMessageSelector);

    const [{confirmErrors, errorCheck} ,  setconfirmErrors] = useState({
        confirmErrors: '',
        errorCheck: false
    });

    const successCallback = (data) => {
        setUserAgree(data);
    }
    
    const errorCallback = () => {
    }

    const dataTerms = {
        token,
        agency_name,
        agent_name,
        address,
        gstin,
        pan_details,
        email,
        mobile
    }

    useEffect(() => {
        setApiError(apiError);
    }, [apiError]);

    useEffect(() => {
        setUserPass({
            user_name: mobileUser,
            password,
            confirm_pass
        })
    }, [mobileUser]);

    // useEffect(() => {
    //     if (mobileUser && !userAgreed) {
    //         let fd = new FormData();
    //         for (const key in dataTerms) {
    //         fd.append(key, dataTerms[key]);
    //         }
    //         dispatch(getTerms(fd, successCallback, errorCallback));
    //     }
    // }, [mobileUser]);

    const minPwdLen = 8;

    const onChangeHandler = (field, value) => {
        const data = {
            user_name,
            password,
            confirm_pass
        };
        data[field] = value;
        setUserPass(data);
        if (field === 'password') {
            onKeyPress(data[field]);
        }
    }

    const fieldValidators = {
        'user_name': {'field': 'user_name', 'fieldName': 'User name', 'validators': ['required']},
        'password': {'field': 'password', 'fieldName': 'Password', 'validators': ['required']},
    };

    const validateField = (field, dataObj) => {
        const errorObj = {...errors};
        if (fieldValidators[field]) {
            errorObj[field] = '';
            const validators = fieldValidators[field].validators;
            for (let i = 0; i < validators.length; i++) {
            const validateFunction = validations[validators[i]];
            const validateDataObj = {
                value: dataObj[field],
                fieldName: fieldValidators[field].fieldName,
                length: minPwdLen
            };
            const resp = validateFunction(validateDataObj);
            if (resp && !errorObj[field]) {
                errorObj[field] = resp;
            }
            }
        }
        setError(errorObj);
    };

    const validateFields = (data) => {
        let errorObj = {};
        Object.keys(data).map(key => {
            if (fieldValidators[key]) {
                const validators = fieldValidators[key].validators;
                for (let i = 0; i < validators.length; i++) {
                    const validateFunction = validations[validators[i]];
                    const validateDataObj = {
                        value: data[key],
                        fieldName: fieldValidators[key].fieldName,
                        length: minPwdLen
                    };
                    const resp = validateFunction(validateDataObj);
                        if (resp && !errorObj[key]) {
                        errorObj[key] = resp;
                    }
                }
            }
        });
        setError(errorObj);
        if (Object.keys(errorObj).length) {
            return true;
        }
        return false;
    }

    const setUserNamePass = (event: React.FormEvent) => {
        sendEvarData({
            prop54: "myPatner|signup|setPassword|getStarted"
        }, true)
        event.preventDefault();
        const data = {
            user_name,
            // ...((!account_exists || (account_exists && verify_mmt_password)) && {password: password} ),
            password,
            // confirm_pass,
        };
        const hasError = validateFields(data);
        if (!hasError) {
            setPassword(data);
        }
    };

    const onKeyPress = (val) => {
        validateField('password', {password: val});
    }

    // const onBlur = (field, val) => {
    //     validateField(field, {confirm_pass: val});
    // }

    return(
        <C.PopContentMainWrap>
            <C.PopContentHeadWrap>
                <C.PopContentHeadText>You’re Almost done!</C.PopContentHeadText>
                {/* <C.PopContentSubHeadText>You may choose to login using your makemytrip account password.</C.PopContentSubHeadText> */}
            </C.PopContentHeadWrap>
            <C.PopContentInnerWrap>
                <S.InfoTextWrap>
                    <S.InfoText>Since you have a MakeMyTrip account linked with the same mobile number, quickly complete your account by entering MakeMyTrip password linked to this mobile number.</S.InfoText>
                </S.InfoTextWrap>
                <C.UserInfoForm onSubmit={setUserNamePass}>
                    <C.InputWrapper>
                        <C.CommonInputWrap>
                            <S.UserNameHeadText>Mobile Number</S.UserNameHeadText>
                            <S.UsernameWrap>
                                <IconSelector iconKey="india" />
                                <S.LoginPrefix>+91</S.LoginPrefix>
                                <S.LoginNumber>{mobileUser}</S.LoginNumber>
                            </S.UsernameWrap>
                            <C.ErrorText>{errors['user_name']}</C.ErrorText>
                        </C.CommonInputWrap>
                    </C.InputWrapper>
                    <C.InputWrapper>
                        <C.CommonInputWrap>
                            <C.CommonLabel>Password</C.CommonLabel>
                            <C.CommonInput
                                type={!showPassword ? 'password' : 'text'}
                                placeholder="Password"
                                name="password"
                                value={password}
                                onChange={event => {
                                    onChangeHandler('password', event.target.value);
                                }}
                                hasError={errors['password'] ? true : false}
                            ></C.CommonInput>
                            <C.ErrorText>{errors['password']}</C.ErrorText>
                            <S.EyeWrapper>
                                <Eye
                                    showPassword={showPassword}
                                    setShowPassword={() => setShowPassword(!showPassword)}
                                />
                            </S.EyeWrapper>
                        </C.CommonInputWrap>
                    </C.InputWrapper>
                    {account_exists && verify_mmt_password ? (
                        forgotPasswordLoader ? (
                            <S.ResetBtnWrap disabled={true}>
                                <ButtonLoader loaderType="gstin"/>
                            </S.ResetBtnWrap>
                        ) : (
                            <S.ResetBtnWrap>
                                <S.ResetOption onClick={onforgotPwdClickHandler}>Reset Password</S.ResetOption>
                            </S.ResetBtnWrap>
                        )
                    ) : null}
                    <C.ApiErrorText>
                        {apiErrorMsg && apiErrorMsg.screen === 'setpassword' ? apiErrorMsg.msg : ''}
                    </C.ApiErrorText>
                    <C.ApiErrorText>
                        {tokenApiMessage}
                    </C.ApiErrorText>
                    <C.ButtonWrap>
                        {/* <S.TnCtext>By proceeding, you agree to MakeMyTrip'sT&CsandPrivacy</S.TnCtext> */}
                        <C.ContinueButton type="submit">{setLoader ? <ButtonLoader loaderType="button" /> : 'CONTINUE'}</C.ContinueButton>
                    </C.ButtonWrap>
                </C.UserInfoForm>
            </C.PopContentInnerWrap>
        </C.PopContentMainWrap>
    )
}

export default AlmostDone;